import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconShuffleComponent } from "./med-icon-shuffle.component";

@NgModule({
  declarations: [
    MedIconShuffleComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconShuffleComponent,
  ],
})
export class MedIconShuffleModule { }
